//Api
import * as api from 'api/cdc'
import * as docsetAPI from 'api/docset'
import * as featureAPI from 'api/feature'

//Types
import { Collection, CDC, CDCInfo, CollectionInfo, DefaultContext, CDCVersion } from 'types/cdc'
import { Format } from 'types/format'

export function retrieveCollection(alias:string, cfr:string, requestor: string | null):Promise<Collection> {
  return Promise.all([
    api.info(alias, cfr),
    api.cdcs(alias, cfr, requestor),
    api.toc(alias, cfr, requestor),
    api.versions(alias)
  ]).then(([
    info,
    cdcs,
    toc,
    versions
  ]) => {
    let uniqueVersions = versions.reduce((unique: CDCVersion[], o) => {
      let found = unique.find(obj => {
        return obj.softwareVersion === o.softwareVersion
      })
      if (found) {
        if (!found.supportedInd && o.supportedInd) {  //if not supported was stored and dup entry with supported was found, overwrite to be supported
          found.supportedInd = true
          
        }
      } else {
        unique.push(o)
      }
      return unique;
    },[]);

    versions = uniqueVersions
    return {
      info: info as CollectionInfo,
      cdcs,
      toc,
      versions
    }
  })
}

export function retrieveCDC(alias: string, cfr:string, requestor: string | null):Promise<CDC> {
  return Promise.all([
    api.info(alias, cfr),
    api.toc(alias, cfr, requestor),
    api.versions(alias),
    api.docsetCollection(alias,cfr)
  ]).then(([
    info,
    toc,
    versions,
    cdcDocsets
  ]) => {
    info.cdcDocsets = cdcDocsets

    let uniqueVersions = versions.reduce((unique: CDCVersion[], o) => {
      let found = unique.find(obj => {
        return obj.softwareVersion === o.softwareVersion
      })
      if (found) {
        if (!found.supportedInd && o.supportedInd) {  //if not supported was stored and dup entry with supported was found, overwrite to be supported
          found.supportedInd = true
          
        }
      } else {
        unique.push(o)
      }
      return unique;
    },[]);

    versions = uniqueVersions

    return {
      info: info as CDCInfo,
      toc,
      versions
    }
  })
}

// Things we need on docset load
// 1. Languages for Docset
// 2. Alternative Docset Versions
// 3. Default Feature Flags
export function retrieveDocset(lang: string, alias: string, cfr: string, requestor: string | null): Promise<any> { // TODO: Figure out why Promise<Docset> didn't work
  return Promise.all([
    docsetAPI.languages(alias, cfr),
    docsetAPI.versions(alias, cfr),
    featureAPI.featureFlags(alias, cfr, lang, requestor)
  ])
    .then(([languages, versions, featureFlags]) => {
      return {
        languages,
        versions,
        featureFlags
      }
    })
}

export function retrieveDefaultContext(alias: string, cfr: string): Promise<DefaultContext> {
  return api.defaultContext(alias,cfr).then(defaultContext => { return defaultContext})
}

export function retrieveUrl( source: any, alias: string, cfr: string, docset: string, format: Format, lang:string): Promise<string> {
  return api.formatAvailable(source, alias, cfr, docset, format, lang).then(result => result)
}


export const home = api.home